module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog2-cbc47606bf5c77e93dc3c86161b28177.jpg";